import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as debinActions } from "reducers/debin";
import gaEventTracker, { events } from "util/gaEventTracker";
import AnulateDebinSummaryBody from "./components/SummaryAnulate";

const AnulateDebinSummaryPage = () => {
    const { debinDetail, sentRequests } = useSelector((state) => state.debin);
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === debinDetail?.id);
    const { accounts } = useSelector((state) => state.accounts);
    const data = {
        documentNumber: debinDetail?.sellerDetail?.documentNumber,
        id: debinDetail?.id,
    };
    const accountseller = accounts?.find((object) => object?.cbu?.substring(9) === receivedDebin?.seller?.cbu);
    const debitAccountMask = `****${accountseller?.shortLabel?.substring(1)}`;

    const handleSubmit = (params) => {
        gaEventTracker.triggerEvent(events.debin_eliminar());
        return debinActions.cancelRequest(params);
    };

    return (
        <>
            <Notification scopeToShow="/debinPayments" />
            <ResponsiveHeader id="debin.anuate.emmited" />
            <MainContainer>
                <div className="container">
                    <I18n id="debin.summary.anulate" />
                    <AnulateDebinSummaryBody
                        debitAccount={debitAccountMask || "-"}
                        buyerName={debinDetail?.sellerDetail?.titular || "-"}
                        buyerCuit={
                            `${debinDetail?.sellerDetail?.documentType} ${debinDetail?.sellerDetail?.documentNumber}` ||
                            "-"
                        }
                        curency={debinDetail?.amount?.currency || "-"}
                        amount={debinDetail?.amount?.quantity || "-"}
                        solicitDate={debinDetail?.creationDate || "-"}
                        dueDate={debinDetail?.expirationDate || "-"}
                        debinId={debinDetail?.id || "-"}
                        buyerCbu={debinDetail?.sellerDetail?.cbu || "-"}
                        alias={debinDetail?.sellerDetail?.cbuAlias || "-"}
                        bank={debinDetail?.sellerDetail?.bank || "-"}
                        concept={debinDetail?.concept || "-"}
                        description={debinDetail?.description || "-"}
                        reference={debinDetail?.reference || "-"}
                        creditAccount={receivedDebin?.seller?.shortLabel || "-"}
                        voucher={debinDetail?.idVoucher || "-"}
                    />
                    <GeneralCredentialForm
                        transactionData={data}
                        action={debinActions.cancelRequest}
                        idActivity="debin.cancel.sentRequest.send"
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default AnulateDebinSummaryPage;
